import { SessionRow } from './session-row';
import type { Session } from '@pulse/shared';

export function SessionList({ siteId, sessions }: { siteId: string; sessions: Session[] }) {
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-bg-surface">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border bg-bg-surface">
            {['Visitor', 'Duration', 'Pages', 'Entry page', 'Device', 'Country', 'Flags', 'Started', ''].map((h) => (
              <th key={h} className="text-left text-[10px] font-semibold uppercase tracking-wider text-text-muted px-3.5 h-8">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sessions.map((s) => (
            <SessionRow key={s.id} siteId={siteId} session={s} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
